<template>
    <div>
        <button v-if="isSuperAdmin" class="btn btn-outline-primary" type="button" v-b-modal="'import'">
            <span>{{ $t('lbl_EMPBE_ReportAll_Title_Button_ImportData') }}</span>
        </button>

        <DialogModal :id="'import'" @callBackConfirm="Import()" ref="ImportModal" :ConfirmText="$t('lbl_EMPBE_ReportAll_component_Import_Import')" :CancelText="$t('lbl_EMPBE_ReportAll_component_Cancel')" >
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_ImportUpdateData') }}
                </div>
                <div class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_Title') }}
                </div>
            </div>
                <!--Data layer-->
                <div v-if="isSuperAdmin" class="Data-Layer">
                    <div class="mb-2 Modal-SubTitle">
                        {{ $t('lbl_EMPBE_ReportAll_component_DataLayer') }}
                    </div>
                    <b-form-group>
                        <div class="radio d-flex radio-primary mb-2">
                            <b-form-radio v-model="ExportOptions.DataLayer" id="SystemData" name="DataLayer"
                                value="SystemData" class="my-auto">
                            </b-form-radio>
                            <label name="All" class="LayeredLabel" for="SystemData">
                                <div class="Main-Text">{{ $t('lbl_EMPBE_ReportAll_component_SystemData') }}</div>
                                <div class="Sub-Text">{{ $t('lbl_EMPBE_ReportAll_component_SystemData_Text') }}</div>
                            </label>
                        </div>

                        <div class="radio d-flex radio-primary mb-2">
                            <b-form-radio v-model="ExportOptions.DataLayer" id="SupplierData" name="DataLayer"
                                value="SupplierData" class="my-auto">
                            </b-form-radio>
                            <label for="SupplierData" class="LayeredLabel">
                                <div class="Main-Text">{{ $t('lbl_EMPBE_ReportAll_component_SupplierData') }}</div>
                                <div class="Sub-Text">{{ $t('lbl_EMPBE_ReportAll_component_SupplierData_Text') }}</div>
                            </label>
                        </div>

                        <div class="radio d-flex radio-primary ">
                            <b-form-radio v-model="ExportOptions.DataLayer" id="UniversalData" name="DataLayer"
                                value="UniversalData" class="my-auto">
                            </b-form-radio>
                            <label for="UniversalData" class="LayeredLabel">
                                <div class="Main-Text">{{ $t('lbl_EMPBE_ReportAll_component_UniversalData') }}</div>
                                <div class="Sub-Text">{{ $t('lbl_EMPBE_ReportAll_component_UniversalData_Text') }}</div>
                            </label>
                        </div>
                    </b-form-group>
                </div>
            <b-form-file class="mb-4" v-model="ImportFile" :state="Boolean(ImportFile)" placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..." accept=".xlsx"></b-form-file>
        </DialogModal>

        <DialogModal :id="'loading'" :NoDefaultBtn="true" :DisableClickOutSideToClose="LockLoadingScreen" 
        :noFade="true" ref="LoadingModal" >
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle DotLoading">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_CheckingMergeData') }}
                </div>
                <div class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_NoRefreshText') }}
                </div>
            </div>
            <template #ExtraBtn>
                <button :disabled="LockLoadingScreen" class="btn btn-primary" type="button" @click="toggleModal()">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_Importing') }}
                 </button>
            </template>
        </DialogModal>

        <DialogModal :id="'Success'" :noFade="true" ref="SuccessModal" :isOkayOnly="true" :ConfirmText="$t('lbl_EMPBE_ReportAll_component_Import_OK')">
            <div class="d-flex flex-column mb-3">
                <div class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_ImportSuccessfully') }}
                </div>
                <div class="Modal-TitleDesc">
                    <div v-if="ExportOptions.DataLayer != 'UniversalData'">
                        {{ $t('lbl_EMPBE_ReportAll_component_Import_SuccessfullyText',{number:InsertedDataNo}) }}
                    </div>
                    <div v-if="ExportOptions.DataLayer == 'UniversalData'">
                        {{ $t('lbl_EMPBE_ReportAll_component_Universal_SuccessfullyText') }}
                    </div>
                </div>
            </div>
        </DialogModal>

        <DialogModal :id="'Failed'" :noFade="true" ref="FailedModal" :isOkayOnly="true" :ConfirmText="$t('lbl_EMPBE_ReportAll_component_Import_OK')">
            <div class="d-flex flex-column mb-3">
                <div v-if="!IsReject" class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_ImportFailed') }}
                </div>
                <div v-if="IsReject" class="mb-1 Modal-MainTitle">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_Importrejected') }}
                </div>
                <div v-if="!IsReject" class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_ImportFailed_Text') }}
                    <br>
                    <br>
                    <ul class="text-danger">
                        <li class="bullet" v-for="item in ErrorMsg">{{ GetErrorReason(item) }}</li>
                    </ul>

                </div>
                <div v-if="IsReject" class="Modal-TitleDesc">
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_Importrejected_DifferentStatuses') }}
                    <br/>
                    <span v-if="CorrectStatus=='REVIEW'">  {{ $t('lbl_EMPBE_ReportAll_component_Import_Importrejected_DifferentStatusesText_Review') }}</span>
                    <span v-if="CorrectStatus=='PENDING'">{{ $t('lbl_EMPBE_ReportAll_component_Import_Importrejected_DifferentStatusesText_Preparation') }}</span>
                    <!-- -->
                    <br/>
                    {{ $t('lbl_EMPBE_ReportAll_component_Import_Importrejected_DifferentStatusesText2') }}
                </div>
            </div>
        </DialogModal>


    </div>

</template>
<script>

import DialogModal from '../../../components/popup/dialogModal.vue'
import { reportService } from '@/_services/report.service';

export default {
    props: ["SelectedEdition", "isSuperAdmin"],
    components: {
        DialogModal
    },
    data(){
        return{
            ImportFile : null,
            ExportOptions: {
                DataLayer: this.isSuperAdmin ? "SystemData" : "SupplierData",
            },
            LockLoadingScreen :false,
            InsertedDataNo : 0,
            ErrorMsg : [],
            IsReject : false
        }
    },
    computed:{
        CorrectStatus(){
            if(this.DataLayer ==  "SystemData"){
                return this.$t(`lbl_EMPBE_AutoReport_PENDING`)
            }
            return  this.$t(`lbl_EMPBE_AutoReport_REVIEW`)
        }
    },
    methods:{
        async UploadExcel(ImportFile){

            if(!this.ExportOptions.DataLayer){
                return
            }

            var formData = this.GetUploadExcelFormData()

            this.LockLoadingScreen = true;
            
            this.$refs.ImportModal.CloseModal();
            this.$refs.LoadingModal.ShowModal();

            await reportService.UploadExcel(formData).then(res => {
                this.$refs.LoadingModal.CloseModal();
                if(res && res.isSuccessful){
                    this.InsertedDataNo = res.data.insertedRowNo
                    this.$refs.SuccessModal.ToggleModal();
                }
                else{
                    this.IsReject = !res?.data.isStatusValid;
                    this.ErrorMsg = res.data.invalidReason
                    this.$refs.FailedModal.ToggleModal();
                }
                this.$emit('SoftReload');
            }).finally(() => {

                this.LockLoadingScreen = false;

            })
        },
        async Import(){
             await this.UploadExcel(this.ImportFile);           
        },
        GetUploadExcelFormData(){
            var formData = new FormData();
            formData.append('File', this.ImportFile);
            formData.append('DataLayer', this.ExportOptions.DataLayer);
            formData.append('BatchId', this.SelectedEdition);
            
            return formData;
        },
        GetErrorReason(ErrorItem){
            var TranslateKey = ""
            if(ErrorItem.errorType == 0){
                TranslateKey = 'lbl_EMPBE_AutoReport_ImportError_NonNumeric'
            }

            if(ErrorItem.errorType == 1){
                TranslateKey = 'lbl_EMPBE_AutoReport_ImportError_CellDataEmpty'
            }

            if(ErrorItem.errorType == 2){
                TranslateKey = 'lbl_EMPBE_AutoReport_ImportError_HeaderNotMatch'
            }
            console.log(ErrorItem.violatedCellAddress)

            return this.$t(TranslateKey, {Address:ErrorItem.violatedCellAddress,Data: ErrorItem.violatedCellContent })
        }

    }
}
</script>


<style>
.bullet{
    font-size: 14px;
    margin-left: 10px;
    list-style-type: circle;
}
</style>